/* eslint-disable no-console */

import * as _ from 'lodash';
import { valuesAreEqual, clone, getTagUniqueIdentifier } from './utils';

export default angular.module('cian.newbuild.filter.tagsService', [])
.factory('FilterTagsService', [
  '$log',
  'TagTitleService',
  'RegionUtilsService',
  ($log, TagTitleService, RegionUtilsService) => {
  const service = {
    // Список тегов, новые теги добавляются в начало списка
    // все теги храняться в _tags, а в tags только те, которые
    // должны выводится как теги (filterCouldBeShownAsTag)
    // это нужно, потому что при переключении типа недвижимости
    // теги становятся быстрыми фильтрами и наоборот
    _tags: [],
    tags: [],
  };

  // magic number из библиотеки jsondiffpatch
  const ARRAY_MOVE = 3;

  /** @type {string[]} */
  const basicIgnoredKeys = [
    'engine_version',
    'page',
    'region',

    // Сортировка
    'sort',
    'quality',

    // Типы объектов:
    'room', // жилая
    'object_type', // загородка
    'office_type', // коммерческая

    'room_types',
    'bed_space',
    'flat',

    // Не показываем новостройки и вторичку, так как они теперь выводятся в offer-type-browser
    'building_status',

    // Может быть только быстрым фильтром
    'is_by_homeowner',

    // Теги для расстояния до меро
    'only_foot',
    'foot_min'
  ];

  /** @type {string[]} */
  const metroDistanceTags = [
    'only_foot',
    'foot_min'
  ];

  /** @type {string[]} */
  let additionalIgnoredFiltersList;

  /**
   * @type {object}
   * @property isNewBuilding
   */
  let dealInfo;

  const ignoredValuesForKeys = {
    room(value) {
      return value !== 0 && value !== 10;
    },
    for_day(value) {
      // Не показываем для посуточной и всей длительной
      return value !== '1' && value !== '!1';
    },
  };

  function filterNeverCouldBeShownAsTag(key) {
    return _.includes(basicIgnoredKeys, key);
  }

  function filterMetroDistanceTags(key) {
    return _.includes(metroDistanceTags, key);
  }

  function filterCouldBeShownAsTag(key, value) {
    const keysToIgnore = _.union(basicIgnoredKeys, additionalIgnoredFiltersList);

    return !_.includes(keysToIgnore, key) &&
          (!ignoredValuesForKeys[key] || ignoredValuesForKeys[key](value));
  }

  function findTagIndex(key, type, value) {
    return service._tags.findIndex(tag => {
      return tag.key === key && tag.type === type && valuesAreEqual(type, tag.value, value);
    });
  }

  function checkTagIsUnderground(tagValue) {
    return (typeof tagValue === 'object' && tagValue.type === 'underground');
  }

  function addTag(key, type, value) {
    if (filterMetroDistanceTags(key) || checkTagIsUnderground(value)) {
      service.isMetroTag = true;
    }
    if (!filterNeverCouldBeShownAsTag(key)) {
      const newTag = {
        key,
        type,
        value: clone(type, value),
      };
      newTag.uniqueId = getTagUniqueIdentifier(newTag);
      newTag.title = TagTitleService.getTitle(newTag, dealInfo);
      service._tags.unshift(newTag);
    }
  }

  function editTag(key, type, oldValue, value) {
    if (!filterNeverCouldBeShownAsTag(key)) {
      const index = findTagIndex(key, type, oldValue);

      if (index < 0) {
        addTag(key, type, value);
      } else {
        const tag = service._tags[index];
        tag.value = clone(type, value);
        tag.uniqueId = getTagUniqueIdentifier(tag);
        tag.title = TagTitleService.getTitle(tag, dealInfo);
      }
    }
  }

  function removeTag(key, type, oldValue) {
    if (!filterNeverCouldBeShownAsTag(key) && !filterMetroDistanceTags(key)) {
      const index = findTagIndex(key, type, oldValue);

      if (index > -1) {
        service._tags.splice(index, 1);
      } else {
        $log.error('Can\'t find tag to remove', key, type, oldValue);
      }
    }
  }

    /**
     * @param {Boolean} value?
     */
  service.toggleMetroTag = (value = false) => {
    service.isMetroTag = value;
  };

  /**
   * @param {object} filtersDiff
   * @param {object} filterInfoByKey
   * @param {string[]} ignoredFiltersList - список фильтров, которые не нужно выводить в тэги
   * @param {object} newDealInfo
   * @param {string} newDealInfo.isNewBuilding
   * @param {string} newDealInfo.dealType
   */
  service.updateTags = (filtersDiff, filterInfoByKey, ignoredFiltersList, newDealInfo) => {
    additionalIgnoredFiltersList = ignoredFiltersList;
    dealInfo = newDealInfo;

    angular.forEach(filtersDiff, (item, key) => {
      const type = filterInfoByKey[key].type;

      // Документация по jsondiffpatch https://github.com/benjamine/jsondiffpatch/blob/master/docs/deltas.md
      const itemValue = item.value;
      // Изменение внутри массива
      if (itemValue._t === 'a') {
        // Проходим по всем ключам кроме _t, ключи начинающиеся
        // с _ указывают на удалённые или передвинутые элементы
        angular.forEach(itemValue, (v, k) => {
          if (k !== '_t') {
            if (k.indexOf('_') === 0) { // moved or deleted
              // const index = k.substring(1); // comment because unused
              // moved [movedItemValue(suppresed by default), destinationIndex, 3]
              if (v[2] === ARRAY_MOVE) {
                // const destinationIndex = v[1]; // comment because unused
                $log.error('Unexpected move within an array', item, key);
              } else { // deleted [oldValue, 0, 0]
                removeTag(key, type, v[0]);
              }
            } else { // inserted
              // TODO FIXME
              // Когда меняешь полигон на карте (например, двигаешь),
              // разница находится в item.geo.value[%index%].geoObject.source.geometry.coordinates,
              // индексы '0' и '_0'.
              // @see http://s.csssr.ru/2016-04-25-2238-qx6blbebsn.png
              // закрыл тем, что ничего не делаем, если в v[0] undefined.
              // В любом случае не нужно добавлять тег, передавая undefined третьем аргументом,
              // это ломается при выводе тегов и при фильтрации гео объектов.
              // Возможно нужно обрабатывать именно изменение координат.
              if (v[0]) {
                addTag(key, type, v[0]);
              }
            }
          }
        });
      } else {
        const valueLength = itemValue.length;
        if (valueLength === 1) { // added [newValue]
          if (type === 'terms') {
            itemValue[0].forEach(valueToAdd => {
              addTag(key, type, valueToAdd);
            });
          } else {
            addTag(key, type, itemValue[0]);
          }
        } else if (valueLength === 2) { // edited [oldValue, newValue]
          if (type === 'terms' && itemValue[0] === null) {
            angular.forEach(itemValue[1], value => {
              addTag(key, type, value);
            });
          } else {
            editTag(key, type, itemValue[0], itemValue[1]);
          }
        } else if (valueLength === 3) { // deleted [oldValue, 0, 0]
          if (type === 'terms' || type === 'geo') {
            angular.forEach(itemValue[0], value => {
              removeTag(key, type, value);
            });
          } else {
            removeTag(key, type, itemValue[0]);
          }
        }
      }
    });

    service.tags = service._tags
      .filter(tag => filterCouldBeShownAsTag(tag.key, tag.value));

    service.isMetroTag = service.tags
      .filter(tag => checkTagIsUnderground(tag.value))
      .length > 0;
  };

  return service;
}])
.name;



// WEBPACK FOOTER //
// ./src/serp/services/filter-tags.service.js